import { ExtendedField } from '../../disclosure/models/loan-application.model';

export class PropertyInformationModel {
  addressConfidentiality?: boolean;
  addressConfidentialityId?: number;
  borrowerCommunityState?: boolean;
  cCostOfImprovement?: number;
  city?: string;
  closingId?: number;
  constToPermClosingType?: number;
  cOriginalCost?: number;
  costOfImprovement?: number;
  county?: string;
  energyEfficientMortgage?: boolean;
  estate?: number;
  expirationDate?: Date;
  fileDataId?: number;
  fileName?: string;
  fhamcawId?: number;
  gifts?: GiftModel[];
  grossRentalIncome?: number;
  hasCleanEnergyLien?: boolean;
  indianCountryLandTenure?: number;
  isConstConvOrConstPerm?: boolean;
  isConversionOfLandContract?: boolean;
  isPropertyAddressTBD?: boolean;
  isRefiConstruction?: boolean;
  isRenovation?: boolean;
  isNewConstructionID?: number;
  isNewConstruction?: boolean;
  landLoanStatus?: number;
  loanId?: string;
  lotAcquiredDate?: Date;
  mannerTitle?: string;
  mixedUse?: number;
  netRentalIncome?: number;
  numberOfUnits?: number;
  projectClassification?: number;
  propertyCommunityState?: boolean;
  projectName?: string;
  propertyType?: number;
  rAmountExistingLiens?: number;
  secondaryId?: number;
  sentToCondoProcessing?: boolean;
  state?: string;
  street?: string;
  subPropId?: number;
  titleHolders?: TitleHolderModel[];
  trustInformation?: number;
  unitNumber?: string;
  userId?: number;
  vacancyFactor?: number;
  zip?: string;
  yearBuilt?: number;
  mailAway?: ExtendedField<boolean>;
  powerOfAttorney?: ExtendedField<boolean>;
  mhAdvantage?: ExtendedField<boolean>;

  // For UI only.
  giftsForUi?: GiftModel[];
}

export interface GiftModel {
  borrowerId?: number;
  cashOrMarketValue?: number;
  depositedStatus?: number;
  fileDataId?: number;
  giftId?: number;
  giftSource?: number;
  giftType?: number;
  isDeleted?: boolean;
  showAddButton?: boolean;
}

export class TitleHolderModel {
  displayOrder?: number;
  dob?: Date;
  email?: string;
  firstName?: string;
  isBorrower?: boolean;
  lastName?: string;
  middleName?: string;
  ssn?: string;
  suffix?: string;
  titleHolderId?: number;
  isDeleted?: boolean;
  mobilePhone: string;
  homePhone: string;
  workPhone: string;
}
